<div class="row">
    <div class="col-lg-8 mx-auto mb-4">
        <ul class="nav nav-tabs border-0 rounded-pill bg-white my-4">
            <li class="nav-item w-50 m-0">
                <a class="nav-link text-center font-weight-bold text-uppercase" routerLink="login" routerLinkActive="active">Login</a>
            </li>
            <li class="nav-item w-50 m-0">
                <a class="nav-link text-center font-weight-bold text-uppercase" routerLink="register" routerLinkActive="active">Register</a>
            </li>
        </ul>
    </div>
</div>


<router-outlet></router-outlet>